<div class="ft-expandable-content"
     [ngClass]="{ 'is-expanded': isExpanded(), 'is-collapsed': isBeingCollapsed() }">
    <div class="ft-expandable-bg">
        <div class="ft-bg-image"
             [style.background-image]="expandableBgImage() ? 'url(' + expandableBgImage() + ')' : null"></div>
        <div class="ft-bg-matte"></div>
    </div>

    <div class="ft-container ft-expandable-close-container">
        <button class="ft-btn-close" (click)="collapse($event)"></button>
    </div>

    <div class="ft-container ft-expandable-trigger-container">
        <div class="ft-expandable-trigger ft-panel" (click)="expand()">
            <div class="ft-panel-bg"
                 [style.background-image]="collapsedBgImage() ? 'url(' + collapsedBgImage() + ')' : null"></div>
            <ng-content select="collapsed" />
        </div>
    </div>

    <div class="ft-primary-area">
        <div class="ft-container">
            <ng-content select="primary" />
        </div>
    </div>

    <div class="ft-custom-area">
        <ng-content select="custom" />
    </div>

    <!-- v1 appended .ft-secondary-area last, only when <panel>s existed. -->
    @if (hasSecondary()) {
        <div class="ft-secondary-area">
            <ng-content select="secondary" />
        </div>
    }
</div>
